import api from './apiConfig';

const BASE_URL = '/api/registry';

const registryService = {
  getAll: async (page = 0, size = 10) => {
    try {
      const response = await api.get(`${BASE_URL}?page=${page}&size=${size}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching registries:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching registry ${id}:`, error);
      throw error;
    }
  },

  getByCode: async (code) => {
    try {
      const response = await api.get(`${BASE_URL}/code/${code}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching registry with code ${code}:`, error);
      throw error;
    }
  },

  create: async (registry) => {
    try {
      const response = await api.post(BASE_URL, registry);
      return response.data;
    } catch (error) {
      console.error('Error creating registry:', error);
      throw error;
    }
  },

  update: async (id, registry) => {
    try {
      const response = await api.put(`${BASE_URL}/${id}`, registry);
      return response.data;
    } catch (error) {
      console.error(`Error updating registry ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      await api.delete(`${BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error deleting registry ${id}:`, error);
      throw error;
    }
  },

  // Data operations
  syncData: async (registryId) => {
    try {
      await api.post(`${BASE_URL}/${registryId}/sync`);
    } catch (error) {
      console.error(`Error syncing data for registry ${registryId}:`, error);
      throw error;
    }
  },

  getData: async (registryId, page = 0, size = 10) => {
    try {
      const response = await api.get(`${BASE_URL}/${registryId}/data?page=${page}&size=${size}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching data for registry ${registryId}:`, error);
      throw error;
    }
  },

  searchData: async (registryId, searchTerm, page = 0, size = 10) => {
    try {
      const response = await api.get(`${BASE_URL}/${registryId}/data/search?searchTerm=${searchTerm}&page=${page}&size=${size}`);
      return response.data;
    } catch (error) {
      console.error(`Error searching data for registry ${registryId}:`, error);
      throw error;
    }
  },

  addData: async (registryId, data) => {
    try {
      const response = await api.post(`${BASE_URL}/${registryId}/data`, data);
      return response.data;
    } catch (error) {
      console.error(`Error adding data to registry ${registryId}:`, error);
      throw error;
    }
  },

  updateData: async (registryId, dataId, data) => {
    try {
      const response = await api.put(`${BASE_URL}/${registryId}/data/${dataId}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating data ${dataId} in registry ${registryId}:`, error);
      throw error;
    }
  },

  deleteData: async (registryId, dataId) => {
    try {
      await api.delete(`${BASE_URL}/${registryId}/data/${dataId}`);
    } catch (error) {
      console.error(`Error deleting data ${dataId} from registry ${registryId}:`, error);
      throw error;
    }
  },

  // Entry operations
  getEntriesByRegistryId: async (registryId) => {
    try {
      const response = await api.get(`${BASE_URL}/${registryId}/entries`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching entries for registry ${registryId}:`, error);
      throw error;
    }
  },

  addEntry: async (registryId, entry) => {
    try {
      const response = await api.post(`${BASE_URL}/${registryId}/entries`, entry);
      return response.data;
    } catch (error) {
      console.error(`Error adding entry to registry ${registryId}:`, error);
      throw error;
    }
  },

  updateEntry: async (registryId, code, entry) => {
    try {
      const response = await api.put(`${BASE_URL}/${registryId}/entries/${code}`, entry);
      return response.data;
    } catch (error) {
      console.error(`Error updating entry ${code} in registry ${registryId}:`, error);
      throw error;
    }
  },

  deleteEntry: async (registryId, code) => {
    try {
      await api.delete(`${BASE_URL}/${registryId}/entries/${code}`);
    } catch (error) {
      console.error(`Error deleting entry ${code} from registry ${registryId}:`, error);
      throw error;
    }
  },

};

export default registryService; 